import { render, staticRenderFns } from "./Bookclassmgr.vue?vue&type=template&id=47d32618&scoped=true&"
import script from "./Bookclassmgr.vue?vue&type=script&lang=js&"
export * from "./Bookclassmgr.vue?vue&type=script&lang=js&"
import style0 from "./Bookclassmgr.vue?vue&type=style&index=0&id=47d32618&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d32618",
  null
  
)

export default component.exports